import classNames from "classnames"
import React from "react"

import type { LinkListProps } from "@bounce/web-components"
import { LinkList } from "@bounce/web-components"

import { useSectionViewed } from "@/hooks/useSectionViewed"

export type PlaceListProps = {
  title: string
  links: LinkListProps["links"]
  className?: string
  children?: React.ReactNode
}

export const PlaceList = ({ title, links, className, children }: PlaceListProps) => {
  const { sectionRef } = useSectionViewed({ name: "PlaceList" })

  return (
    <section ref={sectionRef} className={classNames("mx-auto w-full max-w-screen-xl px-6", className)}>
      <div className="relative w-full">
        <h2 className="title2 pr-24 text-black md:max-w-[600px]">{title}</h2>
        <LinkList links={links} as="nav" />
        {children}
      </div>
    </section>
  )
}
